import React, { useMemo } from "react";
import CommentsPanel from "../components/comments/CommentsPanel";
import { createPodcastCommentsAdapter } from "../components/comments/adapters";
import { getAuthToken } from "../utils/auth";
import "./PodcastThoughts.css";

export default function PodcastThoughts({ podcastId }) {
  const [token, setToken] = React.useState(() => getAuthToken());

  React.useEffect(() => {
    const handleUpdate = () => setToken(getAuthToken());
    window.addEventListener("userUpdated", handleUpdate);
    window.addEventListener("storage", handleUpdate);
    return () => {
      window.removeEventListener("userUpdated", handleUpdate);
      window.removeEventListener("storage", handleUpdate);
    };
  }, []);

  const adapter = useMemo(() => {
    if (!podcastId) {
      return null;
    }
    return createPodcastCommentsAdapter(podcastId, token);
  }, [podcastId, token]);

  if (!podcastId || !adapter) {
    return null;
  }

  return (
    <CommentsPanel
      entityType="podcast"
      entityId={String(podcastId)}
      adapter={adapter}
      canComment={true}
      variant="podcast"
    />
  );
}
